module.exports = __webpack_public_path__ + "img/service.71abc394.svg";